import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C } from "@/helpers/global";

export const SettingService = {
    Init(callback) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.SETTING + "/init").then((data) => {
            callback(true, data);
        }).catch((err) => {
            if (!err) { err = {}; }
            callback(false, C.Str(C.Str(err.statusText, err.message), "There was a problem with the server! Please try again"));
        });
    },
    InitAsync() {
        return new Promise((resolve, reject) => {
            Ajax.Api(MethodType.Get, Enums.SERVICE.SETTING + "/init").then((data) => {
                resolve(data);
            }).catch((err) => {
                reject(C.Str(C.Str(err.statusText, err.message), "There was a problem with the server! Please try again"));
            });
        });
    },
};